import styled from 'styled-components';

const Button = styled.button`
  padding: 8px 25px;
  width: 100%;
  margin-right: 0;
  font-family: 'Arial';
  font-weight: bold;
  font-size: 20px;
  background-color: #001e5a;
  border: 2px solid #001e5a;
  color: #FFFFFF;
`;

export default Button;
